import { render, staticRenderFns } from "./useCoupon.vue?vue&type=template&id=ee47774c&scoped=true&"
import script from "./useCoupon.vue?vue&type=script&lang=js&"
export * from "./useCoupon.vue?vue&type=script&lang=js&"
import style0 from "./useCoupon.vue?vue&type=style&index=0&id=ee47774c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee47774c",
  null
  
)

export default component.exports